<template>
  <div class="content">
    <section class="page-intro">
      <p><span class="f-ticker">Posts</span></p>
      <p class="tag-list">
        <span class="tag">signals in static</span>
      </p>
    </section>
    <section class="posts">
      <ul class="posts-list">
        <PostListItem
          v-for="post in posts"
          :key="post.id"
          :title="post.title"
          :description="post.description"
          :tags="post.tags"
          :link="post.link"
          :image="post.image"
        />
      </ul>
    </section>
    <section class="empty">
      <div class="row">
        <div class="column column-50">
          <div class="empty-image">
            <svg
              width="401"
              height="301"
              viewBox="0 0 401 301"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M162 180.25L1 301L0.400391 300.2L162 179V180.25ZM401 1L241 120.999V119.75L400.4 0.200195L401 1Z"
                stroke="#3A3A3A"
                style="
                  stroke: #3a3a3a;
                  stroke: color(display-p3 0.2275 0.2275 0.2275);
                  stroke-opacity: 1;
                "
                stroke-width=".5"
                vector-effect="non-scaling-stroke"
              />
              <path
                d="M239.4 180.25L400.4 301L401 300.2L239.4 179V180.25ZM0.400391 1L160.4 120.999V119.75L1 0.200195L0.400391 1Z"
                stroke="#3A3A3A"
                style="
                  stroke: #3a3a3a;
                  stroke: color(display-p3 0.2275 0.2275 0.2275);
                  stroke-opacity: 1;
                "
                stroke-width=".5"
                vector-effect="non-scaling-stroke"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PostListItem from "@/components/posts/PostListItem.vue";

const posts = ref([
  {
    id: "figma-for-marketers",
    title: "Figma—not just for designers.",
    description:
      "A no-nonsense intro for marketers, writers, and anyone who needs to get in, get out, and not screw things up.",
    tags: ["Jun 24, 2025"],
    link: "/writing/figma-for-marketers",
    image: {
      type: "video",
      src: require("@/assets/posts/click-in.mp4"),
      mimeType: "video/mp4",
      alt: "Figma click-in demonstration",
    },
  },
  {
    id: "illegal-hacks-for-after-effects",
    title: "A cheat sheet for After Effects.",
    description:
      "A cheat sheet of shortcuts for the most unintuitive piece of software Adobe has ever made. And that's saying a lot.",
    tags: ["June 24, 2025"],
    link: "/writing/a-cheat-sheet-for-after-effects",
    image: {
      type: "video",
      src: require("@/assets/posts/alt-f4.mp4"),
      mimeType: "video/mp4",
      alt: "After Effects shortcuts demonstration",
    },
  },
]);
</script>

<style lang="scss" scoped>
.posts {
  background-color: var(--color-page-initial);
  padding: 0;
  .posts-list {
    margin: 0;
    padding: 0;
  }
}
.empty {
  display: flex;
  flex: 1;
  .empty-image {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    svg {
      width: 100%;
      height: auto;
    }
  }
}
</style>
